import styles from "@css/modules/pointsGuide.module.scss"
import cn from "classnames"
import { create } from "canvas-confetti"
import { useEffect, useRef } from "react"
import { useRouter } from "next/navigation"
import { NumberAnimation } from "@components/Animation/Number"
import Image from "next/image"
import step6Coin from "@public/images/pointsGuide/step6Coin.webp"

function randomInRange(min, max) {
    return Math.random() * (max - min) + min
}

export function Step6Header({ goToStart, data }) {
    /**
     * @type {React.MutableRefObject<HTMLCanvasElement>}
     */
    const canvasRef = useRef(null)
    useEffect(() => {
        const conf = create(canvasRef.current, {
            resize: true
        })
        let interval
        function frame() {
            if (document.visibilityState === "visible") {
                // from left
                conf({
                    spread: 250,
                    ticks: 400,
                    particleCount: 15,
                    startVelocity: 20,
                    scalar: randomInRange(0.5, 1),
                    gravity: randomInRange(0.6, 0.9),
                    drift: 1,
                    angle: 60,
                    origin: {
                        x: 0,
                        y: -0.5
                    }
                })

                // from right
                conf({
                    spread: 250,
                    ticks: 400,
                    particleCount: 20,
                    startVelocity: 20,
                    scalar: randomInRange(0.5, 1),
                    gravity: randomInRange(0.6, 0.9),
                    drift: -1,
                    angle: 120,
                    origin: {
                        x: 1,
                        y: -0.5
                    }
                })
            }
            interval = setTimeout(frame, 300)
        }
        frame()

        return () => {
            clearTimeout(interval)
            conf.reset()
        }
    }, [])

    const router = useRouter()
    const goToListings = () => {
        router.push("/listings")
    }
    return (
        <div className={cn(styles.stepHeader, styles.step6Header)} id="scroll-target">
            <div className={styles.left}>
                <canvas ref={canvasRef} className={styles.canvas} />
                <div className={styles.text}>
                    We recommend a Disney <br /> Vacation Club Membership with
                </div>
                <div className={styles.points}>
                    <span className={styles.numWrapper}>
                        <NumberAnimation value={data["6"]} def={100} />
                    </span>
                    Points
                    <Image className={styles.icon} src={step6Coin} alt="coins" />
                </div>
            </div>
            <div className={styles.right}>
                <div className={styles.rightTitle}>Are you all set to buy your ideal contract ?</div>
                <div className={styles.btnRow}>
                    <button className={styles.viewListingsBtn} onClick={goToListings}>
                        View Listings
                    </button>
                    <button className={styles.startOverBtn} onClick={goToStart}>
                        Start Over
                    </button>
                </div>
            </div>
        </div>
    )
}
